import { useState } from "react";
import { Sparkles } from "lucide-react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { api, errMsg } from "@/lib/api";
import { ProLocked } from "@/components/agyin/ProExtras";

const EXAMPLES = { materials: "art paper 130gsm SRA3, substrate, cost 5 per sheet", work_centers: "Konica digital press, 2000 sheets an hour, 10 min setup" };
export const AI_SECTIONS = Object.keys(EXAMPLES);

export function EstimatingAiFill({ section, pro, onRow }) {
  const [text, setText] = useState("");
  const [busy, setBusy] = useState(false);
  if (!pro) return <div className="border-b border-slate-200 p-4"><ProLocked testId={`ai-fill-locked-${section}`} text="Upgrade to Agyin Pro to describe an entry in plain language and have Agyin fill the fields." /></div>;
  const fill = async () => {
    setBusy(true);
    try { const r = (await api.post("/agyin/estimating-fill", { section, text })).data; onRow(r.row); setText(""); toast.success("Agyin added a draft row. Review it, then click Save."); if (r.usage?.notice) toast.warning(r.usage.notice); }
    catch (e) { toast.error(errMsg(e)); }
    setBusy(false);
  };
  return (
    <div className="flex flex-wrap items-center gap-2 border-b border-slate-200 p-4" data-testid={`ai-fill-${section}`}>
      <Sparkles className="h-4 w-4 text-[#2B7F77]" /><span className="text-sm font-medium text-slate-700">Describe it</span>
      <Input data-testid={`ai-fill-input-${section}`} className="min-w-[260px] flex-1" value={text} onChange={(e) => setText(e.target.value)} placeholder={`e.g. ${EXAMPLES[section]}`} onKeyDown={(e) => { if (e.key === "Enter" && text.trim().length > 2 && !busy) fill(); }} />
      <Button size="sm" data-testid={`ai-fill-button-${section}`} disabled={busy || text.trim().length < 3} onClick={fill} className="bg-[#13294B] hover:bg-[#1c3a66]">{busy ? "Filling…" : "Fill with Agyin"}</Button>
      <span className="w-full text-xs text-slate-500">Agyin adds a draft row to the table below. Nothing is saved until you review it and click Save.</span>
    </div>);
}
